// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ChevronsRight as RawChevronsRight } from "lucide-react";
export const ChevronsRight = /* @__PURE__ */ createIcon(RawChevronsRight, "ChevronsRight", 2);
